<template>
  <v-alert v-if="store.error" type="error" density="compact">
    <v-row>
      <v-col class="grow">
        Fehler: {{store.error.message}}
      </v-col>
      <v-col class="shrink">
        <v-btn @click="store.fetch" size="small" :loading="store.loading">Erneut versuchen</v-btn>
      </v-col>
    </v-row>
  </v-alert>
  <Loading v-else-if="store.loading" />
  <v-select
    v-else
    v-bind="$attrs"
    :single-line="!showLabel"
    :density="!showLabel ? 'compact' : 'default'"
    label="Bediener"
    v-model="internalValue"
    item-title="Name"
    item-value="Kuerzel"
    :items="filteredItems"
    :loading="store.loading"
    :disabled="disabled"
    placeholder="--- Bediener wählen ---"
  />
</template>

<script lang="ts" setup>
import {useBedienerStore} from '@/store/bediener';
import Loading from '@/components/Loading.vue';
import {computed} from 'vue';
const store = useBedienerStore();
store.fetch().catch(console.error);
const props = defineProps<{
    modelValue?: string
    showLabel?: boolean
    disabled?: boolean
    skipped?: Record<string, true>
}>();

const emit = defineEmits({'update:modelValue': (data: string) => typeof data === 'string'});

const internalValue = computed({
  get() {
    return props.modelValue || '';
  },
  set(newVal: string) {
    emit('update:modelValue', newVal);
    return;
  },
});

const filteredItems = computed(
    () => store.data.filter((bediener) => !props.skipped ||!props.skipped[bediener.Kuerzel] || bediener.Kuerzel === props.modelValue).map((s) => {
      return {Kuerzel: s.Kuerzel, Name: `${s.Name} (${s.Kuerzel})`};
    }),
);

defineExpose({
  store,
  internalValue,
  fetch,
  props,
  Loading,
  Error,
  filteredItems,
});
</script>
